<template>
  <b-modal :model-value="true">
    <ld-modal-content title="Recording Options">
      <template #default>
        <ld-form without-content-wrapper>
          <template #default>
            <input-with-validation
              b-name="input"
              field-label="Name"
              rules="required"
              v-model="form.label"
              placeholder="Enter recording name"
            />
            <input-with-validation field-label="Media Type" rules="required" v-model="form.record_options">
              <template #custom="{ handleChange }">
                <div class="is-flex" style="gap: 10px;">
                  <div class="control">
                    <b-checkbox v-model="form.record_options" native-value="video" @update:modelValue="handleChange">Video</b-checkbox>
                  </div>
                  <div class="control">
                    <b-checkbox v-model="form.record_options" native-value="audio" @update:modelValue="handleChange">Audio</b-checkbox>
                  </div>
                </div>
              </template>
            </input-with-validation>
            <input-with-validation
              b-name="input"
              field-label="Duration (minutes)"
              type="number"
              rules="required|integer|min_value:1|max_value:10"
              v-model="form.duration_minutes"
              min="1"
              max="10"
              sublabel="Maximum: 10 minutes"
            />
          </template>
          <template #footer="{ meta }">
            <div class="is-flex is-justify-content-center" style="gap: 10px;">
              <button class="button is-text" @click="$emit('close')">Cancel</button>
              <button class="button is-primary" @click="save" :disabled="!meta.valid">Record</button>
            </div>
          </template>
        </ld-form>
      </template>
    </ld-modal-content>
  </b-modal>
</template>

<script>
import LdModalContent from "@/components/LdModalContent.vue";
import InputWithValidation from "@/components/validation/InputWithValidation.vue";
import LdForm from "@/components/LdForm.vue";

export default {
  name: 'ManualRecordingModal',
  components: {
    LdModalContent,
    InputWithValidation,
    LdForm
  },
  data() {
    return {
      form: {
        label: '',
        duration_minutes: 1,
        record_options: ['video'],
      },
    }
  },
  methods: {
    save() {
      this.form.record_video = this.form.record_options.includes('video');
      this.form.record_audio = this.form.record_options.includes('audio');

      const cloned_form = { ...this.form }
      delete cloned_form.record_options

      this.$emit('save', cloned_form);
    }
  }
}
</script>